import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export interface GetSubmittedFileNames {
  AuthNo: string,
  CompanyId: string,
  SubmittedFileNames: Array<string>
}

export interface UploadState {
  selectedFile?: any,
  selectedFileList: []
}

export interface FileTag {
  name: string;
  value: string;
}

export const uploadFilestoAuth = (options: Object) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.UPLOAD_AUTH_FILES_REQUEST });

  return api.authorization.files.upload(options)
    .then((res: any) => {

      dispatch({
        type: types.UPLOAD_AUTH_FILES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.UPLOAD_AUTH_FILES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getSubmittedFileNames = (model: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_SUBMITTED_FILE_NAMES_REQUEST });

  return api.authorization.files.getSubmittedFileNames(model)
    .then((res: any) => {

      dispatch({
        type: types.GET_SUBMITTED_FILE_NAMES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_SUBMITTED_FILE_NAMES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getAllFilesByTags = (companyId: string, tags: FileTag[]) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_ALL_FILES_BY_TAGS_REQUEST });

  let request = {
    "user": "SESUPPORT",
    "application": "letter-generation",
    "ipa": companyId,
    "prefix": "none",
    tags
  };

  return api.authorization.files.getAllFilesByTags(request)
    .then((res: any) => {

      dispatch({
        type: types.GET_ALL_FILES_BY_TAGS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_ALL_FILES_BY_TAGS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const downloadFile = (companyId: string, filepath: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.DOWNLOAD_AUTH_FILE_REQUEST });

  let request = {
    "user": "SESUPPORT",
    "application": "letter-generation",
    "ipa": companyId,
    "filenameWithPath": filepath
  };

  return api.authorization.files.download(request)
    .then((res: any) => {

      dispatch({
        type: types.DOWNLOAD_AUTH_FILE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.DOWNLOAD_AUTH_FILE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};


export const downloadFileFromBlob = (companyId: string, application: string, filepath: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.DOWNLOAD_FILE_BLOB_REQUEST });

  let request = {
    "user": sessionStorage.getItem('user_id'),
    "application": application,
    "ipa": companyId,
    "filenameWithPath": filepath
  };

  return api.authorization.files.download(request)
    .then((res: any) => {

      dispatch({
        type: types.DOWNLOAD_FILE_BLOB_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.DOWNLOAD_FILE_BLOB_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};